import ChatbotProcessCase from './ChatbotProcessCase';

export default ChatbotProcessCase;